var fivePointOffset = function (val, value) {
    return value == 5
        ? 3
        : val >= 0 && val < 10
            ? 0
            : val >= 10 && val < 20
                ? 0.4
                : val >= 20 && val < 90
                    ? 1
                    : val >= 90 && val < 100
                        ? 1.1
                        : val == 100
                            ? -0.15
                            : 1.2;
};
var tenPointOffset = function (val, value) {
    return value == 10
        ? 3
        : val >= 0 && val < 10
            ? 0
            : val >= 10 && val < 40
                ? 0.2
                : val >= 40 && val < 50
                    ? 1.2
                    : val >= 50 && val < 100
                        ? 2.2
                        : val == 100
                            ? -0.15
                            : 1.2;
};
var offsetByProfile = {
    fivePoint: fivePointOffset,
    tenPoint: tenPointOffset,
};
export var getLeftOffsetByProfile = function (profile) {
    var getOffsetValue = offsetByProfile[profile];
    return function (val, value) {
        return "calc(".concat(val, "% - ").concat(getOffsetValue(val, value), "em)");
    };
};
